import router from '@/router';
import { getCookies } from '@/utils/cookies';
import { Message } from '@/utils/message';
import axios, { AxiosRequestConfig, Canceler } from 'axios';
axios.defaults.timeout = 120000;
axios.defaults.baseURL = '';

axios.interceptors.request.use(
    config => {
        // config.headers['model-type'] = 'see3d';
        // config.headers['token'] = getCookies('access_token');
        return config;
    },
    error => {
        return Promise.reject(error.response);
    }
);
/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
axios.interceptors.response.use(
    response => {
        const responseCode = response.status;
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (responseCode >= 200 && responseCode < 300) {
            if(response.data?.code != 200) {
                response.data?.data && Message.error(response.data?.data)
            }
            return Promise.resolve(response);
        } else {
            console.log(response);
            return Promise.reject(response);
        }
    },
    error => {
        if(error?.response?.status == 400) {
            router.push('/login');
        }
        console.log('response', error);
        return Promise.reject(error);
    }
);

export async function cancelRequest(config: AxiosRequestConfig, hasErrTips = false) {
    // 创建一个取消令牌
    const CancelToken = axios.CancelToken;
    let cancel: Canceler | undefined;

    const axioRequest = async () => {
        return await request(
            {
                ...config,
                cancelToken: new CancelToken(c => (cancel = c)),
            },
            hasErrTips
        ).finally(() => {
            cancel = undefined;
        });
    };
    const cancelAxioRequest = () => cancel && cancel('Operation canceled by the user.');
    return {
        axioRequest,
        cancelAxioRequest,
    };
}

export async function request(config: AxiosRequestConfig, hasErrTips = false) {
    try {
        const data = await axios({
            ...config,
            params: {
                ...(config.params || {}),
            },
        });
        return data.data;
    } catch (e: any) {
        const message = e.message;
        message && Message.error(e.response?.data?.msg || e.response?.data?.detail?.msg || e.message);

        if (axios.isCancel(e)) {
            return Promise.reject('Request canceled' + message);
        }
        if (e.name === 'AxiosError') {
            return Promise.reject(e);
        }
        if (!hasErrTips && e.response?.data?.type === 'need_auth') {
            const currentPath = location.hash;
        }

        return Promise.reject(Error(message));
    }
}
